module.exports = __webpack_public_path__ + "img/icon-info.054be127.svg";